module.exports = __webpack_public_path__ + "img/methodOrange.33da18f0.jpg";